import { ajaxRequest, hideSpinner, showSpinner } from "../../Utils/Ajax/ajax";
import { getTableLang } from "../../Utils/Inits/getTableLang";
import { errorToast, infoToast, makeModal, successToast } from "../../Utils/utils";
import { changeTestSetting } from "../TestList/changeTestSetting";


export class AdminAbManager {
    constructor(){
        this.table = $("#ab-liste table");
        this.tableData = this.initTable();
        this.addListeners();
    }

    initTable(){
        const zeilen = ['AB', 'ABs'];
        return this.table.DataTable({
            language: getTableLang({}, zeilen),
            columnDefs: [
                {"orderable": false, "targets": [4,5,6]}
            ]
        });
    }

    addListeners(){
        const self = this;
        this.table.on("click", ".edit-code", function(){
            const abId = $(this).parent().data("abid");
            const code = $(this).next().html();
            const submitBtn = {
                text: 'Speichern',
                class: 'save-edit-code',
            }
            const modal = makeModal("editCode", "Code ändern", "Hier kannst du den Code für dieses AB ändern. Über diesen Code können Schüler/-innen direkt oder per QR-Code auf dieses AB zugreifen."+
                ' <div class="d-flex justify-content-center align-items-center">'+
                ' <input type="text" id="ab-unique-code" value="' + code + '" data-ab="' + abId +'" class="form-control form-control-lg text-center check-field" style="width: auto; max-width: 90%;">' +
                ' </div>', submitBtn, true, 'md');
            modal.show();
        });

        $(document).on("click", ".save-edit-code", function(){
            const info = $("#ab-unique-code");
            const newCode = info.val().toString()
            const abId = info.attr('data-ab');

            const url = '/test/' + abId.toString() + '/code/update'

            const success = function (data){
                successToast('Der Code wurde geändert', 'Erfolg', 6500, true);
                const codes = $(".ab-code");
                codes.each(function(ind, obj){
                    const parent = $(obj).parent();
                    if (parent.attr('data-abid') == abId){
                        $(obj).html(newCode);
                    }
                    const myModalEl = document.getElementById('editCode')
                    const modal = bootstrap.Modal.getInstance(myModalEl) // Returns a Bootstrap modal instance
                    modal.hide();
                });
            }

            const data = {
                newCode: newCode
            }

            ajaxRequest(url, success, data, $(this))

        });

        this.table.on("click", ".display-qr-code", function(){
            const myModalEl = document.getElementById("ab-qr-code");
            const myModal = new bootstrap.Modal(myModalEl, {});
            const code = $(this).prev().html();
            const url = "https://rechtschreibtrainer.de/ab/" + encodeURIComponent(code);
            myModal.show();
            $("#code-url").html(url);
            const qrcode = new QRCode("qrcode",{
                text: url,
                width: 128,
                height: 128,
            });
            myModalEl.addEventListener('hide.bs.modal', function(event){
                $("#qrcode").html("");
            });
        });

        $(document).on("click",".download-qr", function(){
            const src = $("#qrcode").find("img").attr('src');
            const a = document.createElement("a");
            a.href = src;
            const code = $("#code-url").html().split("ab/")[1];
            a.download = "QrCode-" + code + ".png";
            a.click();
        });

        this.table.on("click", ".go-to-test", function(){

            showSpinner($(this))

            const url = $(this).attr('data-url');

            const code = $(this).parent().parent().find(".ab-code")[0].innerHTML

            window.location = url + '/' + code;

            hideSpinner($(this))

        })

        this.table.on("click", ".ab-setting", function(){
            const newStatus = ($(this).hasClass("text-success")) ? 0 : 1;
            const setting = $(this).attr('data-setting');
            const abId = $(this).parent().attr('data-ab');
            const button = $(this);
            changeTestSetting(abId, setting, newStatus, button);
        });

    }
}
